import React from "react";
import { Link } from "react-router-dom";

import "./styles/footer.css";

const Footer = () => {
	return (
		<React.Fragment>
			<div className="footer">
				<div className="footer-links">
					<ul className="footer-nav-link-list">
						<li className="footer-nav-link-item">
							<Link to="/">Home</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/about">About</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/projects">Projects</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/articles">Articles</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/contact">Contact</Link>
						</li>
					</ul>
				</div>

				<div className="footer-credits">
					<div className="footer-credits-text">
						© 2023 Konica Minolta Printer Repair. Design by
					</div>
				</div>
				<div className="footer-credits">
          <p style={{ color: "black" }}>
            
            <a
              href="https://allymutabazi.netlify.app/"
              rel="nofollow"
              style={{ color: "blue" }}
            >
              Ally M
            </a>
          </p>
        </div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
